module.exports = __webpack_public_path__ + "static/media/AC.1f309a21.svg";